<template>
    <div class="main-page">
        <template v-if="showHeader">
            <section class="page-section mb-3" >
                <div class="container">
                    <div class="grid justify-content-between">
                        <div class="col " >
                            <div class="">
                                <div class=" text-2xl text-primary font-bold" >
                                    Add New Auto Payments
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </template>
        <section class="page-section " >
            <div class="container">
                <div class="grid ">
                    <div class="md:col-9 sm:col-12 comp-grid" >
                        <div class="">
                            <div class="">
                                <div >
                                    <form ref="observer" tag="form" @submit.prevent="submitForm()" class="" :class="{ 'card': !isSubPage }">
                                        <div class="grid">
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Account Number 
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <InputText ref="ctrlaccount_number" v-model.trim="formData.account_number"  label="Account Number" type="text" placeholder="Enter Account Number"      
                                                        class=" w-full" :class="getErrorClass('account_number')">
                                                        </InputText>
                                                        <small v-if="isFieldValid('account_number')" class="p-error">{{ getFieldError('account_number') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Customer Name 
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <InputText ref="ctrlcustomer_name" v-model.trim="formData.customer_name"  label="Customer Name" type="text" placeholder="Enter Customer Name"      
                                                        class=" w-full" :class="getErrorClass('customer_name')">
                                                        </InputText>
                                                        <small v-if="isFieldValid('customer_name')" class="p-error">{{ getFieldError('customer_name') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Customer Id 
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <InputText ref="ctrlcustomer_id" v-model.trim="formData.customer_id"  label="Customer Id" type="number" placeholder="Enter Customer Id"   step="any"    
                                                        class=" w-full" :class="getErrorClass('customer_id')">
                                                        </InputText>
                                                        <small v-if="isFieldValid('customer_id')" class="p-error">{{ getFieldError('customer_id') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Last Bill Amount 
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <InputText ref="ctrllast_bill_amount" v-model.trim="formData.last_bill_amount"  label="Last Bill Amount" type="number" placeholder="Enter Last Bill Amount"   step="0.1"    
                                                        class=" w-full" :class="getErrorClass('last_bill_amount')">
                                                        </InputText>
                                                        <small v-if="isFieldValid('last_bill_amount')" class="p-error">{{ getFieldError('last_bill_amount') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Last Bill Date 
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <Calendar :showButtonBar="true" :showTime="true" dateFormat="yy-mm-dd" hourFormat="24" v-model="formData.last_bill_date" :showIcon="true" class="w-full" :class="getErrorClass('last_bill_date')"     mask="yy-MM-DD HH:mm"     />
                                                        <small v-if="isFieldValid('last_bill_date')" class="p-error">{{ getFieldError('last_bill_date') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Msisdn 
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <InputText ref="ctrlmsisdn" v-model.trim="formData.msisdn"  label="Msisdn" type="text" placeholder="Enter Msisdn"      
                                                        class=" w-full" :class="getErrorClass('msisdn')">
                                                        </InputText>
                                                        <small v-if="isFieldValid('msisdn')" class="p-error">{{ getFieldError('msisdn') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Network 
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <InputText ref="ctrlnetwork" v-model.trim="formData.network"  label="Network" type="text" placeholder="Enter Network"      
                                                        class=" w-full" :class="getErrorClass('network')">
                                                        </InputText>
                                                        <small v-if="isFieldValid('network')" class="p-error">{{ getFieldError('network') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Client Request Id 
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <InputText ref="ctrlclient_request_id" v-model.trim="formData.client_request_id"  label="Client Request Id" type="text" placeholder="Enter Client Request Id"      
                                                        class=" w-full" :class="getErrorClass('client_request_id')">
                                                        </InputText>
                                                        <small v-if="isFieldValid('client_request_id')" class="p-error">{{ getFieldError('client_request_id') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="formgrid grid">
                                                    <div class="col-12 md:col-3">
                                                        Transaction Id 
                                                    </div>
                                                    <div class="col-12 md:col-9">
                                                        <InputText ref="ctrltransaction_id" v-model.trim="formData.transaction_id"  label="Transaction Id" type="text" placeholder="Enter Transaction Id"      
                                                        class=" w-full" :class="getErrorClass('transaction_id')">
                                                        </InputText>
                                                        <small v-if="isFieldValid('transaction_id')" class="p-error">{{ getFieldError('transaction_id') }}</small> 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="showSubmitButton" class="text-center my-3">
                                            <Button class="p-button-primary" type="submit" label="Submit" icon="pi pi-send" :loading="saving" />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
	import {  computed,  reactive, toRefs, onMounted } from 'vue';
	import useVuelidate from '@vuelidate/core';
	import { required, numeric, } from '@/services/validators';
	import { useApp } from '@/composables/app.js';
	import { useAddPage } from '@/composables/addpage.js';
	const props = defineProps({
		pageName : {
			type : String,
			default : 'auto_payments',
		},
		routeName : {
			type : String,
			default : 'auto_paymentsadd',
		},
		apiPath : {
			type : String,
			default : 'auto_payments/add',
		},
		submitButtonLabel: {
			type: String,
			default: "Submit",
		},
		formValidationError: {
			type: String,
			default: "Form is invalid",
		},
		formValidationMsg: {
			type: String,
			default: "Please complete the form",
		},
		msgAfterSave: {
			type: String,
			default: "Record added successfully",
		},
		showHeader: {
			type: Boolean,
			default: true,
		},
		showSubmitButton: {
			type: Boolean,
			default: true,
		},
		redirect: {
			type : Boolean,
			default : true,
		},
		isSubPage: {
			type : Boolean,
			default : false,
		},
		pageData: { // use to set formData default values from another page
			type: Object,
			default: () => {} 
		},
	});
	const app = useApp();
	const formDefaultValues = {
		account_number: "", 
		customer_name: "", 
		customer_id: "", 
		last_bill_amount: "", 
		last_bill_date: "", 
		msisdn: "", 
		network: "", 
		client_request_id: "", 
		transaction_id: "", 
	};
	const formData = reactive({ ...formDefaultValues });
	//form validation rules
	const rules = computed(() => {
		return {
			account_number: {  },
			customer_name: {  },
			customer_id: { numeric },
			last_bill_amount: { numeric },
			last_bill_date: {  },
			msisdn: {  },
			network: {  },
			client_request_id: {  },
			transaction_id: {  }
		}
	});
	const v$ = useVuelidate(rules, formData); // form validation
	const page = useAddPage({ props, formData, v$, beforeSubmit, afterSubmit });
	// perform custom validation before submit form
	// set custom form fields
	// return false if validation fails
	function beforeSubmit(){
		return true;
	}
	// after form submited to api
	// reset form data.
	// redirect to another page
	function afterSubmit(response) {
		app.flashMsg(props.msgAfterSave);
		page.setFormDefaultValues(); //reset form data
		if(props.redirect) app.navigateTo(`/auto_payments`);
	}
	//page state
	const {
		submitted, // form submitted state - Boolean
		saving, // form api submiting state - Boolean
		pageReady, // if api data loaded successfully
	} = toRefs(page.state);
	//page methods
	const {
		submitForm, //submit form data to api
		getErrorClass, // return error class if field is invalid- args(fieldname)
		getFieldError, //  get validation error message - args(fieldname)
		isFieldValid, // check if field is validated - args(fieldname)
		 // map api datasource  to Select options label-value
	} = page.methods;
	onMounted(()=>{
		const pageTitle = "Add New Auto Payments";
		app.setPageTitle(props.routeName, pageTitle); // set browser page title
	});
	// expose page object for other components access
	defineExpose({
		page
	});
</script>
<style scoped>
</style>
